/**
 * Save a path to redirect to after login
 * @param {string} path - The path to redirect to
 */
export const saveRedirectPath = (path) => {
  // Don't save redirects for root, login, register, or welcome pages
  if (path && path !== '/' && path !== '/login' && path !== '/register' && path !== '/welcome') {
    console.log('Saving redirect path:', path);
    sessionStorage.setItem('redirectAfterLogin', path);
  }
};

/**
 * Get the path to redirect to after login and clear it from storage
 * @returns {string|null} The path to redirect to, or null if none
 */
export const getAndClearRedirectPath = () => {
  const path = sessionStorage.getItem('redirectAfterLogin');
  console.log('Getting redirect path:', path);
  
  if (path) {
    sessionStorage.removeItem('redirectAfterLogin');
  }
  
  return path;
}; 